import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { Container, VStack, Heading, Text, Card, CardBody, Spinner, Alert, AlertIcon } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { useUserProfile } from '../../contexts/userprofile/UserProfileContext';
import { AccountSettings } from './components/AccountSettings';
import { ProfileSettings } from './components/ProfileSettings';
import { PrivacySettings } from './components/PrivacySettings';
import { UISettings } from './components/UISettings';
import { NotificationSettings } from './components/NotificationSettings';

const sectionComponentMap: Record<string, React.ComponentType<any>> = {
  account: AccountSettings,
  profile: ProfileSettings,
  privacy: PrivacySettings,
  ui: UISettings,
  notifications: NotificationSettings,
};

export const SettingsPage: React.FC = () => {
  const { t } = useTranslation();
  const { accessToken } = useAuth();
  const { profile } = useUserProfile();
  const location = useLocation();

  // Определяем активный раздел по URL
  const match = location.pathname.match(/^\/settings\/(\w+)/);
  const section = match ? match[1] : 'account';
  const ActiveComponent = sectionComponentMap[section] || AccountSettings;

  if (!accessToken) {
    return (
      <Container maxW="container.xl" py={8}>
        <Alert status="warning">
          <AlertIcon />
          {t('settings.notAuthenticated')}
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxW="container.lg" py={8}>
      <VStack spacing={6} align="stretch">
        <Heading size="lg">{t('settings.title')}</Heading>
        <Text color="gray.600" fontSize="md">{t('settings.subtitle')}</Text>
        <Card shadow="sm">
          <CardBody p={6}>
            <ActiveComponent 
              userId={profile?.user_id} 
              profile={profile} 
              onMarkChanged={() => {}} 
              onClearChanges={() => {}} 
            />
          </CardBody>
        </Card>
      </VStack>
    </Container>
  );
}; 